import { Card, CardBody, Row, Col, Placeholder } from "react-bootstrap";
import { FaMoneyBillAlt, FaFileInvoice } from "react-icons/fa";
import { FaBuildingCircleCheck } from "react-icons/fa6";

export default function PaymentsPropertyDetails({ tenantBreakDown, paymentDetails, isLoading }) {

    return (
        <Card className="shadow-lg border-0">
            <CardBody>
                {paymentDetails && paymentDetails.length > 0 ? (
                    <>
                        <h4 className="mb-4 text-warning">
                            <FaMoneyBillAlt className="me-2" />
                            Payment Details
                        </h4>
                        {/* Payment Information */}
                        <Row className="mb-4">
                            <Col md={6}>
                                <div className="mb-3">
                                    <h6 className="text-secondary">Paybill Number</h6>
                                    {isLoading ? (
                                        <Placeholder as="p" animation="glow">
                                            <Placeholder xs={6} />
                                        </Placeholder>
                                    ) : (
                                        <p className="fw-bold">241526</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <h6 className="text-secondary">Account Number</h6>
                                    {isLoading ? (
                                        <Placeholder as="p" animation="glow">
                                            <Placeholder xs={6} />
                                        </Placeholder>
                                    ) : (
                                        <p className="fw-bold">HSE No.</p>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </>
                ) : null}

                {/* Tenant Invoices */}
                <h4 className="mb-4 text-success">
                    <FaFileInvoice className="me-2" />
                    Tenant Invoices
                </h4>

                <Row>
                    <Col md={6}>
                        <div className="mb-3">
                            <h6 className="text-secondary">
                                <FaFileInvoice className="me-2" />
                                 Compliance Tenants
                            </h6>
                            {isLoading ? (
                                <>
                                    <Placeholder as="p" animation="glow" className="mb-2">
                                        <Placeholder xs={8} />
                                    </Placeholder>
                                    <Placeholder as="p" animation="glow">
                                        <Placeholder xs={8} />
                                    </Placeholder>
                                </>
                            ) : (
                                <>
                                    <p className="fw-bold">Invoiced Quarterly: {tenantBreakDown?.quartely_kra}</p>
                                    <p className="fw-bold">Invoiced Monthly: {tenantBreakDown?.monthly_kra}</p>
                                </>
                            )}
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="mb-3">
                            <h6 className="text-secondary">
                                <FaFileInvoice className="me-2" />
                                Non Compliance Tenants
                            </h6>
                            {isLoading ? (
                                <>
                                    <Placeholder as="p" animation="glow" className="mb-2">
                                        <Placeholder xs={8} />
                                    </Placeholder>
                                    <Placeholder as="p" animation="glow">
                                        <Placeholder xs={8} />
                                    </Placeholder>
                                </>
                            ) : (
                                <>
                                    <p className="fw-bold">Invoiced Quarterly: {tenantBreakDown?.quartely_non_kra}</p>
                                    <p className="fw-bold">Invoiced Monthly: {tenantBreakDown?.monthly_non_kra}</p>
                                </>
                            )}
                        </div>
                    </Col>
                </Row>

                {/* Summary Section */}
                <h4 className="mb-3 text-primary mt-2">
                    <FaBuildingCircleCheck className="me-2" />
                    Property Summary
                </h4>
                <Row>
                    <Col md={6}>
                        {isLoading ? (
                            <>
                                <Placeholder as="p" animation="glow" className="mb-2">
                                    <Placeholder xs={10} />
                                </Placeholder>
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={10} />
                                </Placeholder>
                            </>
                        ) : (
                            <>
                                <p className="mb-2">
                                    <span className="fw-bold">Total Compliance Tenants:</span> {tenantBreakDown?.with_kra}
                                </p>
                                <p className="mb-2">
                                    <span className="fw-bold">Total Non Compliance Tenants:</span> {tenantBreakDown?.without_kra}
                                </p>
                            </>
                        )}
                    </Col>
                    <Col md={6}>
                        {isLoading ? (
                            <>
                                <Placeholder as="p" animation="glow" className="mb-2">
                                    <Placeholder xs={10} />
                                </Placeholder>
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={10} />
                                </Placeholder>
                            </>
                        ) : (
                            <>
                                <p className="mb-2">
                                    <span className="fw-bold">Total Invoices Generated:</span> {tenantBreakDown?.kra_invoices_generated}
                                </p>
                                <p className="mb-2">
                                    <span className="fw-bold">Total Generated TAX Income:</span> KSH {tenantBreakDown?.expected_tax?.toLocaleString('en-US')}
                                </p>
                            </>
                        )}
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
}